import fetch from "../fetch";
import pickBy from "lodash/pickBy";

export default ({ params = {}, propertyId } = {}) =>
  fetch({
    path: `/re/prop-masters/${propertyId}/sales`,
    params: pickBy(params)
  });
